// src/components/PartnerSection.js
import React from "react";
import {
    Handshake,
    Percent,
    BadgeCheck,
    Shield,
    Headphones
} from "lucide-react";

// Data array
const partnerItems = [
    { icon: Handshake, text: "For mediators, corporates, advisors" },
    { icon: Percent, text: "Fee-sharing option" },
    { icon: BadgeCheck, text: "White-labelled support" },
    { icon: Shield, text: "Confidential handling" },
    { icon: Headphones, text: "Dedicated partner desk" }
];

const PartnerSection = () => {
    return (
        <>
            {/* [Referral & Partner Program] */}
            <section className="py-16 px-6 md:px-12 lg:px-20 bg-[var(--bg-base)]">
                <div className="max-w-5xl mx-auto">

                    <h2 className="text-3xl font-serif font-semibold text-[var(--text-primary)] text-center">
                        Referral & Partner Program
                    </h2>

                    {/* Subheader line */}
                    <p className="text-center text-[var(--text-secondary)] mt-2 mb-10">
                        Strategic collaboration opportunities designed for professionals and institutions
                    </p>

                    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 lg:gap-6">

                        {partnerItems.map((item, index) => {
                            const Icon = item.icon;

                            return (
                                <div
                                    key={index}
                                    className="flex flex-row items-center gap-4 p-5 lg:min-h-[90px] rounded-xl border border-[var(--border)] bg-white shadow-sm text-left"
                                >
                                    <Icon className="w-7 h-7 text-[var(--color-primary)]" />
                                    <p className="text-[var(--text-primary)]">
                                        {item.text}
                                    </p>
                                </div>
                            );
                        })}

                    </div>
                </div>
            </section>
        </>
    );
};

export default PartnerSection;
